'use es6';

const MOBILE_UA_PARTS = {
  ios: 'iP(hone|od|ad)',
  android: 'Android'
};
export default MOBILE_UA_PARTS;